module.exports = __webpack_public_path__ + "static/media/payments grey.baa82140.svg";